module.exports = __webpack_public_path__ + "img/k1_float_ico.6a9261e1.png";